module.exports = __webpack_public_path__ + "img/北京城市代表性古树-PC三级页面｜内容详情.59bfd443.jpg";